/* global VITE_SUPABASE_SUPPORT_URL, VITE_SUPABASE_SUPPORT_ANON_KEY */
import { createClient } from '@supabase/supabase-js';

// @ts-expect-error - Variables defined in Vite config
const supabaseUrl = VITE_SUPABASE_SUPPORT_URL;
// @ts-expect-error - Variables defined in Vite config
const supabaseAnonKey = VITE_SUPABASE_SUPPORT_ANON_KEY;

export const supabaseSupport = createClient(supabaseUrl, supabaseAnonKey);
